import React from "react";
import { Facet } from "@linkfluence/models/facet";
import Subtitle from "@radarly/components/cards/card/subtitle";
import { GeoCard } from "@radarly/models/cards";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { getTermFromAggs } from "@radarly/models/search";
import Date from "@radarly/shared/cards/subtitle/date";
import Metric from "@radarly/shared/cards/subtitle/metric";
import Tile from "@radarly/shared/cards/tile";
import HorizontalBarChart from "@radarly/shared/widgets/geo/horizontal-bar-chart";
import { useFacets } from "../facets";
import { CardFragmentsProps } from "../model";

const RadarlyGeoCardsHorizontalBarChart = ({
  title,
  fragments,
  project,
  dataviz,
  height,
  onClickItem,
  forceReload,
  timezone,
  nowDate,
  onGenerateCSV,
}: CardFragmentsProps<GeoCard["fragments"], DatavizHorizontalBarChart>) => {
  const fragment = fragments[0];
  const evolutionFragment = fragments[1];
  const facet = useFacets(Facet.Countries, fragment.request.query);
  const term = getTermFromAggs(fragment.request.aggs);
  const metric = fragment.request.aggs[term].metrics[0];
  return (
    <Tile
      title={title}
      height={height}
      subtitle={
        <Subtitle
          meta={[
            <Date fragment={fragment} timezone={timezone} nowDate={nowDate} />,
            <Metric metric={metric} />,
          ]}
        />
      }
      clause={fragment.request.query}
      isPNG
      onGenerateCSV={onGenerateCSV}
    >
      <HorizontalBarChart
        fragment={fragment}
        evolutionFragment={evolutionFragment}
        project={project.id}
        dataviz={dataviz}
        facet={facet}
        onClickGauge={onClickItem}
        forceReload={forceReload}
      />
    </Tile>
  );
};

export default RadarlyGeoCardsHorizontalBarChart;
